import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useOverlayLock } from "@/contexts/UiOverlayContext";
import { useClaimShareReward, copyToClipboard } from "@/lib/share";
import { Loader2 } from "lucide-react";

const SHARE_URL = "https://appfigumatch.xyz";

export default function AhaCelebrationModal({ open, onOpenChange }) {
  useOverlayLock(open);
  const claim = useClaimShareReward();
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);

  // Reset transient state when the modal re-opens
  useEffect(() => {
    if (open) {
      setCopied(false);
      setBusy(false);
    }
  }, [open]);

  async function handleClaim() {
    if (busy || copied) return;
    setBusy(true);
    try {
      await claim.mutateAsync();
    } catch {
      // Even on error we still try to copy the link so the user gets value.
    }
    await copyToClipboard(SHARE_URL);
    setCopied(true);
    setBusy(false);
    // Auto-close after 2s
    setTimeout(() => onOpenChange(false), 2000);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="aha-celebration-modal"
        className="bg-[#0A0A0A] border border-[#E5B83A]/40 text-white max-w-[440px] shadow-[0_0_80px_-20px_rgba(229,184,58,0.55)]"
      >
        <DialogTitle
          data-testid="aha-celebration-title"
          className="font-display text-xl sm:text-2xl font-bold text-white text-center leading-tight"
        >
          🎉 MATCH UNLOCKED! You are on fire.
        </DialogTitle>
        <DialogDescription
          data-testid="aha-celebration-body"
          className="font-body text-sm text-[#A1A1AA] text-center mt-2 leading-relaxed"
        >
          You just entered the trading zone. Share FiguMatch with a fellow
          collector right now and get +10 FiguTokens instantly to unlock future
          premium features.
        </DialogDescription>

        <button
          type="button"
          onClick={handleClaim}
          disabled={busy || copied}
          data-testid="aha-celebration-cta"
          className={
            "mt-6 w-full h-12 rounded-md font-display font-semibold text-sm transition-all " +
            (copied
              ? "bg-[#E5B83A]/20 text-[#E5B83A] border border-[#E5B83A]/40 cursor-default"
              : "bg-gradient-to-r from-[#E5B83A] to-[#C9971C] text-black hover:opacity-95 disabled:opacity-60")
          }
        >
          {busy ? (
            <span className="inline-flex items-center gap-2 justify-center">
              <Loader2 className="h-4 w-4 animate-spin" />
              Claiming…
            </span>
          ) : copied ? (
            "Copied! (+10 Tokens added) ✨"
          ) : (
            "Copy Link & Claim 10 FiguTokens"
          )}
        </button>
      </DialogContent>
    </Dialog>
  );
}
